import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { NgOptimizedImage, SlicePipe } from '@angular/common';
import { Image } from '../../../../pages/product/product-list/product-list.mapper';

@Component({
  selector: 'app-product-images',
  imports: [NgOptimizedImage, SlicePipe],
  templateUrl: './product-images.component.html',
  styleUrls: ['./product-images.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductImagesComponent implements OnInit {
  @Input({ required: true })
  images!: Image[];

  public activeImage: WritableSignal<Image | null> = signal(null);

  ngOnInit(): void {
    this.activeImage.set(
      this.images.find((img) => img.default) ?? this.images[0] ?? null,
    );
  }

  onChangeImage(image: Image): void {
    this.activeImage.set(image);
  }
}
